class WishlistAddedPopover extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.autoFade = null
    this.timeout = 5000
  }

  setupListeners () {
    super.setupListeners()

    const afterAdd = this.handleAfterAdd.bind(this)
    const onClose = this.hideModal.bind(this)

    window.SwymCallbacks.push(swat => {
      swat.evtLayer.addEventListener('sw:addedtowishlist', afterAdd)
    })

    this.els.close.element.addEventListener('click', onClose)
  }

  handleAfterAdd (evt) {
    const {
      detail: {
        d: { dt: swymProductTitle = '', iu: swymProductImage = null } = {},
      } = {},
    } = evt

    this.els.image.element.src = swymProductImage
    this.els.title.element.innerText = swymProductTitle

    this.els.image.element.decode().then(() => {
      this.showModal()
    })
  }

  showModal () {
    if (this.els.modal.exists) {
      this.els.modal.element.setAttribute('aria-hidden', 'false')

      this.autoFade = window.setTimeout(this.hideModal.bind(this), this.timeout)
    }
  }

  hideModal () {
    if (this.autoFade) {
      window.clearTimeout(this.autoFade)
    }

    const onAfterHide = () => {
      this.els.modal.element.removeEventListener('transitionend', onAfterHide)
      this.els.modal.element.setAttribute('aria-hidden', 'true')
      this.els.modal.element.removeAttribute('data-is-hiding')
      this.els.image.element.src = null
      this.els.title.element.innerText = ''
    }

    this.els.modal.element.addEventListener('transitionend', onAfterHide)
    this.els.modal.element.setAttribute('data-is-hiding', true)
  }

  get productId () {
    return this.dataset.productId
  }
}

if (!customElements.get('wishlist-added-popover')) {
  customElements.define('wishlist-added-popover', WishlistAddedPopover)
}
